import React, { useEffect, useState } from 'react';

import { useMediaQuery } from 'react-responsive';

import Text from 'common/components/Text/Text';
import { SessionState } from 'features/session/sessionSlice';
import { useAppSelector } from 'app/hooks';
import { navigateTop } from 'common/utils';
import WorkForm from './WorkForm';
import { CommonHash } from 'app/types';

import styles from './UserInformation.module.scss';
import 'react-phone-input-2/lib/style.css';

interface CompProps {
  currentStep: number;
  setCurrentStep: (n: number) => void;
  answers: CommonHash;
  setAnswer: (h: CommonHash) => void;
  setSaveForm: (b: boolean) => void;
}

const WorkExperience = ({
  currentStep,
  setCurrentStep,
  answers,
  setAnswer,
  setSaveForm,
}: CompProps): React.ReactElement => {
  const { user } = useAppSelector(({ session }: { session: SessionState }) => session);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [noWorkExperience, setNoWorkExperience] = useState<boolean>(
    user?.have_working_experience ? false : true
  );
  const [histories, setHistories] = useState([
    <WorkForm
      index={0}
      key={0}
      answers={answers}
      setAnswer={setAnswer}
      noWorkExperience={noWorkExperience}
    />,
  ]);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const setInputOption = (key: string, value: any) => {
    setAnswer((a: any) => ({ ...a, [key]: value }));
  };

  const handleAddWorkHistory = (e: any) => {
    e.preventDefault();
    setHistories([
      ...histories,
      <WorkForm
        index={histories.length}
        key={histories.length}
        answers={answers}
        setAnswer={setAnswer}
        noWorkExperience={noWorkExperience}
      />,
    ]);
  };

  const handleRemoveWorkHistory = (index: number) => {
    const list = [...histories];
    list.splice(index, 1);
    setHistories(list);
    const workHistories = [...answers['work_history']];
    workHistories.splice(index, 1);
    setAnswer((a: any) => ({
      ...a,
      work_history: workHistories,
    }));
  };

  const hanldeNoWork = () => {
    setNoWorkExperience(!noWorkExperience);
  };

  useEffect(() => {
    if (user?.['work_history'] && user['work_history'].length) {
      const prevHistories: any = [];
      user['work_history'].map((h, index) => {
        prevHistories.push(
          <WorkForm
            index={index}
            key={index}
            answers={answers}
            setAnswer={setAnswer}
            noWorkExperience={noWorkExperience}
          />
        );
      });
      setHistories(prevHistories);
    }
  }, []);

  useEffect(() => {
    setInputOption('have_working_experience', noWorkExperience);
    setHistories([
      <WorkForm
        index={0}
        key={0}
        answers={answers}
        setAnswer={setAnswer}
        noWorkExperience={noWorkExperience}
      />,
    ]);
  }, [noWorkExperience]);

  return (
    <div className={styles.stepContainer}>
      <Text
        size={isMobile ? 16 : 20}
        weight={600}
        color="primary"
        inlineStyle={{ marginBottom: '12px' }}
      >
        My last professional role
      </Text>
      <div className={`form-check ${styles.formGroup}`}>
        <input
          id="no_working_experience"
          className="form-check-input"
          type="checkbox"
          name="flexRadioDefault"
          onChange={() => hanldeNoWork()}
          checked={noWorkExperience}
        />
        <label className={`form-check-label ${styles.formLabel}`} htmlFor="no_working_experience">
          I don&apos;t have working experience
        </label>
      </div>
      <Text
        size={12}
        weight={400}
        color="secondary"
        inlineStyle={{
          marginTop: '6px',
          marginLeft: '20px',
          marginBottom: isMobile ? '24px' : '37px',
        }}
      >
        (Don&apos;t worry, Unify will help you build professional experience.{' '}
        <div
          className={styles.expertLink}
          onClick={() =>
            window.open('https://blog.unifyapply.com/free-application-review/', '_self')
          }
        >
          Contact expert
        </div>
        )
      </Text>
      {histories.map((history, index) =>
        index == 0 ? (
          history
        ) : (
          <div className={styles.historyContainer} key={index}>
            <hr />
            <div className={styles.deleteHistory} onClick={() => handleRemoveWorkHistory(index)}>
              <i className="bi bi-trash"></i>
            </div>
            {history}
          </div>
        )
      )}
      <div className={styles.addMoreHistoryBox} onClick={handleAddWorkHistory}>
        Add more working history +
      </div>
      {isMobile && (
        <>
          <button
            className={styles.nextStepButton}
            onClick={() => {
              setCurrentStep(currentStep + 1);
              navigateTop();
            }}
            disabled={isLoading}
          >
            Next
          </button>
          <button
            className={styles.saveButton}
            onClick={() => {
              setSaveForm(true);
              setIsLoading(true);
            }}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className={`spinner-border ${styles.loading}`} role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              'Save & Leave'
            )}
          </button>
        </>
      )}
    </div>
  );
};

export default WorkExperience;
